import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\krrsw\\development\\skylang\\src\\components\\TeachingStyle\\TeachingStyle.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\styles\\components\\AboutUs.css");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\styles\\components\\Reviews.css");
